import EnrolleeRegistration from './enrollee-registration'

export default EnrolleeRegistration
